import { ToggleButtons } from "@digits-shared/DesignSystem/FormElements/ToggleButtons"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

export const HeaderToggles = styled(ToggleButtons)`
  --toggle-buttons-background: ${colors.translucentWhite20};
  --toggle-buttons-selection-color: var(--header-text-color, ${colors.white});
  --toggle-buttons-selection-background: var(--header-background-color, ${colors.teal});
  --toggle-buttons-selection-shadow: 0 0 0 1px rgba(13, 13, 13, 0.1) inset;
  --toggle-buttons-option-color: ${colors.translucentWhite80};
  --toggle-buttons-hover-background: ${colors.translucentWhite10};
  width: fit-content;
`

export const NavigationToggles = styled(ToggleButtons)`
  --toggle-buttons-background: ${colors.translucentWhite20};
  --toggle-buttons-selection-color: ${colors.white};
  --toggle-buttons-selection-background: ${colors.secondary};
  --toggle-buttons-option-color: ${colors.secondary};
  --toggle-buttons-hover-background: ${colors.translucentSecondary10};
  width: fit-content;
`

export const DetailsHeaderToggles = styled(ToggleButtons)`
  --toggle-buttons-background: ${colors.translucentWhite30};
  --toggle-buttons-hover-background: ${colors.translucentWhite30};
  --toggle-buttons-selection-background: ${colors.white};
  --toggle-buttons-selection-shadow: none;
  --toggle-buttons-v-padding: 4px;
  --toggle-buttons-h-padding: 4px;
  height: 40px;
  gap: 4px;

  .editLedgerEnabled & {
    --toggle-buttons-selection-background: ${colors.accentPeriwinkle};
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding-right: 16px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`
